<template>
  <div class="
    align-center
    flex
    h-full
    justify-center
    pt-52
    sm:flex-col
    sm:justify-start
    sm:mb-14
    sm:pt-14
    sm:px-4
  ">
    <img
      alt="Page Not Found"
      class="flex-grow-0
        flex-shrink-0
        h-[232px]
        mr-[120px]
        self-center
        sm:h-[186px]
        sm:mb-14
        sm:mx-auto
        sm:w-full
      "
      src="@/assets/images/page-not-found.svg"
    />
    <section class="self-center sm:w-full sm:text-center">
      <h1 class=" mb-6 sm:mb-8 sm:font-normal sm:text-2xl text-3.25xl text-border">
        抱歉，找不到您要查看的頁面
      </h1>
      <p>
        您搜尋的頁面已經不存在！
      </p>
      <p>
        系統將在5秒過後自動跳轉回「好彙訂」首頁
      </p>
      <w-button
        class="mt-16 px-16 py-3 sm:w-full"
        @click.prevent="$router.replace('/menu')"
      >
        <span>
          返回首頁
        </span>
      </w-button>
    </section>
  </div>
</template>

<script>
import NotFound from './NotFound';

export default NotFound;
</script>

<style lang="scss" scoped>
@import 'NotFound';
</style>
